<div class="ltms-dropdown" #litmscustomdropdown>
  <button class="ltms-dropdown-button" [disabled]="disabled || readonly" [class.open]="isOpen"
    (click)="openDropDown($event)">
    <div class="button-text">
      <div class="selected-options" *ngIf="(selectedItems && selectedItems.length)">
        <div class="selected-option" *ngFor="let option of selectedItems;">
          {{preffix}} {{ (option && option[textField])? option[textField]: placeholder }} 
          <img src="assets/images/close.svg" style="width: 20px;margin-left: 10px;" (click)="selectOption($event, option)">
        </div>
      </div>
      <div class="placeholder-text" *ngIf="!(selectedItems && selectedItems.length)">
        {{placeholder}}
      </div>

    </div>
    <div class="dropdown-icon">
      <img src="assets/images/menu-down-dark.svg" />
    </div>
  </button>
  <ul [class.show]="isOpen" *ngIf="categorization" class="ltms-dropdown-categorized-list">
    <li class="litmus-dropdown-search-wrapper">
      <input id="litmus-dropdown-search" class="litmus-dropdown-search" autocomplete="off" (keyup)="filterList($event)"
        type="text" placeholder="Search...." />
    </li>
    <ng-container *ngIf="list.length">
      <li *ngFor="let category of list">
        <div class="dropdown-category">
          <div class="category-title">{{preffix}} {{category.category_name}}</div>
        </div>
        <ul class="ltms-dropdown-sub-list">
          <li *ngFor="let option of category.options" (click)="selectOption($event,option);"
            [class.active]="selectedItemIds && selectedItemIds.length &&  selectedItemIds.indexOf(option[uniqueIdField])>=0">
            <img src="assets/images/checkbox-blank-outline.svg"
              *ngIf="!(selectedItemIds && selectedItemIds.length &&  selectedItemIds.indexOf(option[uniqueIdField])>=0)"
              style="width: 24px;">
            <img src="assets/images/checkbox-marked.svg"
              *ngIf="(selectedItemIds && selectedItemIds.length &&  selectedItemIds.indexOf(option[uniqueIdField])>=0)"
              style="width: 24px;">
            {{preffix}} {{option[textField]}}
          </li>
        </ul>
      </li>
    </ng-container>

    <li class="no-result" *ngIf="!list.length">
      no data available for selected filter.
    </li>
  </ul>
  <ul [class.show]="isOpen" *ngIf="!categorization" class="ltms-dropdown-list">
    <li class="litmus-dropdown-search-wrapper">
      <input id="litmus-dropdown-search" class="litmus-dropdown-search" autocomplete="off" (keyup)="filterList($event)"
        type="text" placeholder="Search...." />
    </li>
    <ng-container *ngIf="list.length">
      <li *ngFor="let option of list" (click)="selectOption($event,option)"
        [class.active]="selectedItemIds && selectedItemIds.length &&  selectedItemIds.indexOf(option[uniqueIdField])>=0">
        <img src="assets/images/checkbox-blank-outline.svg"
          *ngIf="!(selectedItemIds && selectedItemIds.length &&  selectedItemIds.indexOf(option[uniqueIdField])>=0)"
          style="width: 24px;">
        <img src="assets/images/checkbox-marked.svg"
          *ngIf="(selectedItemIds && selectedItemIds.length &&  selectedItemIds.indexOf(option[uniqueIdField])>=0)"
          style="width: 24px;">
        {{preffix}}{{option[textField]}}
      </li>
    </ng-container>
    <li class="no-result" *ngIf="!list.length">
      no data available for selected filter.
    </li>
  </ul>
</div>